
import React from 'react';

import PropertyRow from './PropertyRow';

const PropertyRows = ({attrDefs, attrValues}) => {
    return attrDefs.map((item, index) => {
        return (
            <PropertyRow
                key={index}
                title={item[0]}
                value={attrValues[item[1]]}
            />
        );
    });
}

export default PropertyRows;
